// extracted by mini-css-extract-plugin
export default {"DashboardBanner":"DashboardBanner_DashboardBanner__hxt8P","LogoBackdrop":"DashboardBanner_LogoBackdrop__Pm9Jr","DashboardFeaturesList":"DashboardBanner_DashboardFeaturesList__4S2s1"};